import { useEffect, useState } from "react";

export default function useShareDialogUsersTabLoading(activeTab) {
    const [usersTabLoading, setUsersTabLoading] = useState(false);

    useEffect(() => {
        if (activeTab !== 1) {
            setUsersTabLoading(false);
            return undefined;
        }

        if (!usersTabLoading) {
            return undefined;
        }

        const frame = window.requestAnimationFrame(() => {
            setUsersTabLoading(false);
        });

        return () => window.cancelAnimationFrame(frame);
    }, [activeTab, usersTabLoading]);

    return {
        beginUsersTabLoading: () => setUsersTabLoading(true),
        usersTabLoading,
    };
}
